import { getDateOnly, parseDate } from './../helpers/date';

export class DebtTransferInvoice {
  id: string;
  typeableCode: string;
  amount: number;
  cashback: number;
  expiresAt: Date;
  proposalFileId?: string;
  identity?: string;
  name?: string;
  // receives simulation id, in the backend it needs to be simulation the name of the property
  simulation?: string;

  constructor(data: string | DebtTransferInvoice | DjangoDebtTransferInvoice = {}) {
    if (data instanceof DebtTransferInvoice) {
      bindDebtTransferInvoiceData(this, data);
    } else if (typeof data === 'string') {
      bindDjangoDebtTransferInvoiceData(this, { id: data });
    } else {
      bindDjangoDebtTransferInvoiceData(this, data);
    }
  }

  get djangoModel() {
    return getDjangoModel(this);
  }
}

export function parseDebtTransferInvoice(val) {
  if (val) {
    return new DebtTransferInvoice(val);
  } else {
    return undefined;
  }
}

function bindDebtTransferInvoiceData(
  employerInvoice: DebtTransferInvoice,
  data: DebtTransferInvoice,
) {
  employerInvoice.id = data.id;
  employerInvoice.typeableCode = data.typeableCode;
  employerInvoice.amount = data.amount;
  employerInvoice.cashback = data.cashback;
  employerInvoice.expiresAt = data.expiresAt;
  employerInvoice.proposalFileId = data.proposalFileId;
  employerInvoice.identity = data.identity;
  employerInvoice.name = data.name;
  employerInvoice.simulation = data.simulation;
}

///////////////////
// DJANGO SUPPOT //
///////////////////
export interface DjangoDebtTransferInvoice {
  id?: string;
  typeable_code?: string;
  amount?: number;
  cashback?: number;
  expires_at?: string;
  identity?: string;
  proposal_file_id?: string;
  name?: string;
  simulation?: string;
}

function bindDjangoDebtTransferInvoiceData(
  employerInvoice: DebtTransferInvoice,
  data: DjangoDebtTransferInvoice,
) {
  employerInvoice.id = data.id;
  employerInvoice.typeableCode = data.typeable_code;
  employerInvoice.amount = data.amount;
  employerInvoice.cashback = data.cashback;
  employerInvoice.expiresAt = parseDate(data.expires_at);
  employerInvoice.identity = data.identity;
  employerInvoice.proposalFileId = data.proposal_file_id;
  employerInvoice.name = data.name;
  employerInvoice.simulation = data.simulation;
}

function getDjangoModel(debtTransferInvoice: DebtTransferInvoice): DjangoDebtTransferInvoice {
  return {
    id: debtTransferInvoice.id,
    typeable_code: debtTransferInvoice.typeableCode,
    amount: debtTransferInvoice.amount,
    cashback: debtTransferInvoice.cashback,
    identity: debtTransferInvoice.identity,
    proposal_file_id: debtTransferInvoice.proposalFileId,
    name: debtTransferInvoice.name,
    simulation: debtTransferInvoice.simulation,
    expires_at: debtTransferInvoice.expiresAt ? getDateOnly(debtTransferInvoice.expiresAt) : '',
  };
}

export interface DebtTransferInvoicePayload {
  typeableCode: string;
  amount: number;
  expiresAt: Date;
  invoice: File;
}
